import React from "react";
import { operators } from "./QueryConditions";

const ConditionGroup = ({ group, availableFields, onUpdate, level = 0 }) => {
  const updateGroup = (newGroup) => {
    onUpdate(newGroup);
  };

  const updateCondition = (index, key, value) => {
    const updated = { ...group };
    updated.conditions[index][key] = value;
    updateGroup(updated);
  };

  const removeCondition = (index) => {
    const updated = { ...group };
    updated.conditions.splice(index, 1);
    updateGroup(updated);
  };

  const addCondition = () => {
    updateGroup({
      ...group,
      conditions: [
        ...group.conditions,
        {
          type: "condition",
          field: "",
          operator: "=",
          value: "",
        },
      ],
    });
  };

  const addGroup = () => {
    updateGroup({
      ...group,
      conditions: [
        ...group.conditions,
        {
          type: "group",
          operator: "AND",
          conditions: [],
        },
      ],
    });
  };

  const updateSubGroup = (index, newSubGroup) => {
    const updated = { ...group };
    updated.conditions[index] = newSubGroup;
    updateGroup(updated);
  };

  const removeGroup = () => {
    onUpdate(null); // signal parent to delete this group
  };

  return (
    <div
      className={`p-3 border rounded mb-2 bg-white`}
      style={{ marginLeft: level * 20 }}
    >
      <div className="d-flex justify-content-between mb-2">
        <strong>Group ({group.operator})</strong>
        {level > 0 && (
          <button className="btn btn-sm btn-danger" onClick={removeGroup}>
            Remove Group
          </button>
        )}
      </div>

      <div className="mb-2">
        <label className="form-label">Group Operator</label>
        <select
          className="form-select"
          value={group.operator}
          onChange={(e) => updateGroup({ ...group, operator: e.target.value })}
        >
          <option value="AND">AND</option>
          <option value="OR">OR</option>
        </select>
      </div>

      {group.conditions.map((cond, index) => (
        <div key={index}>
          {cond.type === "condition" ? (
            <div className="row mb-2 align-items-end">
              <div className="col-md-4">
                <label className="form-label">Field</label>
                <select
                  className="form-select"
                  value={cond.field}
                  onChange={(e) =>
                    updateCondition(index, "field", e.target.value)
                  }
                >
                  <option value="">-- Select field --</option>
                  {availableFields.map((field) => (
                    <option key={field.code} value={field.code}>
                      {field.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Operator</label>
                <select
                  className="form-select"
                  value={cond.operator}
                  onChange={(e) =>
                    updateCondition(index, "operator", e.target.value)
                  }
                >
                  {operators.map((op) => (
                    <option key={op} value={op}>
                      {op}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Value</label>
                <input
                  type="text"
                  className="form-control"
                  value={cond.value}
                  onChange={(e) =>
                    updateCondition(index, "value", e.target.value)
                  }
                  disabled={cond.operator.includes("NULL")}
                />
              </div>
              <div className="col-md-1">
                <button
                  className="btn btn-sm btn-outline-danger mt-4"
                  onClick={() => removeCondition(index)}
                >
                  ✖
                </button>
              </div>
            </div>
          ) : (
            <ConditionGroup
              key={index}
              group={cond}
              availableFields={availableFields}
              level={level + 1}
              onUpdate={(updated) => {
                if (updated === null) {
                  const copy = [...group.conditions];
                  copy.splice(index, 1);
                  updateGroup({ ...group, conditions: copy });
                } else {
                  updateSubGroup(index, updated);
                }
              }}
            />
          )}
        </div>
      ))}

      <div className="mt-2">
        <button
          className="btn btn-sm btn-outline-primary mr-2"
          onClick={addCondition}
        >
          + Add Condition
        </button>
        <button className="btn btn-sm btn-outline-secondary" onClick={addGroup}>
          + Add Group
        </button>
      </div>
    </div>
  );
};

export default ConditionGroup;
